import {
    isPensionInputStateValid,
} from 'utils/PenlyPlay/penlyPlayPensionHelpers';
import initialState from './initial';
import * as types from '../constants/penlyplay';

const penlyPlayReducers = (state = initialState.penlyplay, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.PENLYPLAY_RESET: {
            const resetState = { ...initialState.penlyplay, ...payload };
            const hasRequiredPensionInput = isPensionInputStateValid(resetState);
            return { ...resetState, hasRequiredPensionInput };
        }
        case types.PENLYPLAY_STATE_UPDATED: {
            const updatedState = { ...state, ...payload };
            const hasRequiredPensionInput = isPensionInputStateValid(updatedState);
            return { ...updatedState, hasRequiredPensionInput };
        }
        default:
            return state;
    }
};

export default penlyPlayReducers;
